import HttpClient from "../httpClient";
import { RoleItem, RoleFilter } from "../../models/types/role";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";

class RolesService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<RoleFilter>): Promise<DefaultResponseContent<RoleItem[]>> {
        const response = await this.service.get<DefaultResponseContent<RoleItem[]>>("/admin/Role/GetListRole", requestData);
        return response;
    }

    async getLookup(): Promise<DefaultResponse<any[]>> {
        const response = await this.service.get<DefaultResponse<any[]>>("/admin/Role/GetRoleLookup");
        return response;
    }

    async getRoleById(id: string): Promise<DefaultResponse<RoleItem>> {
        const response = await this.service.get<DefaultResponse<RoleItem>>(`/admin/Role/GetDetailRole?id=${id}`);
        return response;
    }

    async createRole(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Role/CreateRole`, requestData);
        return response;
    }

    async updateRole(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Role/UpdateRole`, requestData);
        return response;
    }

    async deleteRole(id: number | string): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/Role/DeleteRole?id=${id}`);
        return response;
    }

}

const rolesSvc = new RolesService();
export default rolesSvc;
